import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from 'axios';
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css'
import ValidationService from '@/services/ValidationService';
import HandlePaginateService from "@/services/HandlePaginateService";

export default {
  name: "skillList",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading,
    AdvancedLaravelVuePaginate,
  },

  mixins: [ValidationService],

  data() {
    return {
      initialType: '',
      isFilterOpen: false,
      isLoading: false,
      skillList: [],
      skillHeaders: [],
      searchData: {
        type: "",
        empNumber: "",
        positionId: "",
        empName: "",
      },
      pagination: {},
      positionOptions: [],
      counts: {
        admin: 0,
        teacher: 0,
        total: 0,
      },
      isSearch: 0,
      search_status: false,
      searchedData: null,
      isSearched: false,
      currency: '',
      CONFIG,
    };
  },

  methods: {
    async getList(page = 1) {
      this.search_status = false;
      this.isLoading = true;
      try {
        const response = await axios.get('/skill/list', {
          params: { ...this.searchData, page: page }
        });
        this.skillHeaders = response.data.headers || [];
        this.skillList = response.data.list.data || [];
        this.pagination = response.data.list;
        this.counts = response.data.counts;
        this.initialType = this.searchData.type;
        this.currency = response.data.currency || '';
        this.isLoading = false;
      } catch (error) {
        console.error("Error fetching list", error);
        this.skillList = [];
      } finally {
        this.isLoading = false;
      }
    },

    getAttrAmount(allAttributes, targetName) {
      const attrs = this.parseAttributes(allAttributes);
      const foundAttr = attrs.find(a => a.attr_name === targetName);
      const val = foundAttr != null ? foundAttr.value : null;
      if (val === null || val === undefined || val === '') {
        return '-';
      }
      const num = Number(val);
      if (!Number.isNaN(num)) {
        const amount = num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return `${amount} ${this.currency}`;
      }
      return String(val);
    },

    parseAttributes(data) {
      if (!data) return [];
      return typeof data === 'string' ? JSON.parse(data) : data;
    },

    showEdit(id, empType) {
      let typeId = empType;
  
      if (empType === 'admin') typeId = this.CONFIG.EMPLOYEE_TYPE.ADMIN;
      if (empType === 'teacher') typeId = this.CONFIG.EMPLOYEE_TYPE.TEACHER;
      const finalType = typeId || this.searchData.type;
    
      this.$router.push({
        name: 'skillEdit',
        params: { employeeableId: id, type: finalType }
      });
    },

    async getPosition() {
      try {
        const response = await axios.get('/position/all');
        this.positionOptions = response.data.map(pos => ({
          id: pos.id,
          text: pos.position_name
        }));
      } catch (error) {
        console.error("Failed to fetch positions", error);
      }
    },

    reset() {
      this.searchData = {
        type: "",
        empNumber: "",
        positionId: "",
        empName: "",
      };
      this.isSearched = false;
      this.search_status = false;
      this.isSearch = 0;
      this.isLoading = true;
      this.getList(1);
    },

    async search(page = 1) {
      this.search_status = true;
      this.isLoading = true;
      try {
        this.searchedData = { ...this.searchData };
        this.isSearched = true;
        const response = await axios.get('/skill/search', {
            params: { ...this.searchData, page: page } 
        });
        this.skillHeaders = response.data.headers;
        this.skillList = response.data.list.data;
        this.pagination = response.data.list;
        this.counts = response.data.counts;
        this.initialType = this.searchData.type;
      } catch (error) {
        console.error("Search failed", error);
      } finally {
        this.isLoading = false;
      }
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.search,
        listFn: this.getList
      })
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched ? { ...this.searchedData } : {
        type: "",
        empNumber: "",
        positionId: "",
        empName: "",
      };
      axios.get('/skill/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          let date = new Date();
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `skill_list${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        }) .finally(() => {
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.isLoading = true;
    this.isSearch = 0;
    this.getList();
    this.getPosition();
  },
};
